import * as angular from 'angular';
import { Component, NgModule } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { UpgradeModule, downgradeInjectable } from '@angular/upgrade/static';
import { BrowserModule } from '@angular/platform-browser';
import { UIRouterModule } from '@uirouter/angular';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
import { UrlService} from '@uirouter/core';
import { ApiService } from './app/api-service/api.service';
import { ProfileService } from './app/profile-service/profile.service';
import { MailboxService } from './app/mailbox-service/mailbox.service';
import { ClientConfigService } from './app/client-config-service/client-config.service';
import { CustomerService } from './app/customer-service/customer.service';
import { AuditTrailService } from './app/audit-trail-service/audit-trail.service';
import { YotiService } from './app/yoti-service/yoti.service';

import { AppModule } from './app/app.module';
import { SidebarComponent } from './app/sidebar/sidebar.component';
import { ReissueComponent } from './app/reissue/reissue.component';
import { MailboxComponent } from './app/mailbox/mailbox.component';
import { RewardsComponent} from './app/rewards/rewards.component';

import { MailboxOverlayComponent } from './app/mailbox-overlay/mailbox-overlay.component';
import { MailboxReplyComponent } from './app/mailbox-reply/mailbox-reply.component';
import { MailboxPreviewComponent } from './app/mailbox-preview/mailbox-preview.component';
import { AuditTrailComponent } from './app/audit-trail/audit-trail.component';
import { AuditTrailOverlayComponent } from './app/audit-trail-overlay/audit-trail-overlay.component';
import { RewardsEditOverlayComponent } from './app/rewards-edit-overlay/rewards-edit-overlay.component';

import { app } from './app/angularjs/wpMarketplace.js'

app.config(($locationProvider) => {
    $locationProvider.html5Mode(true);
})

app.factory('apiService', downgradeInjectable(ApiService));
app.factory('mailboxService', downgradeInjectable(MailboxService));
app.factory('profileService', downgradeInjectable(ProfileService));
app.factory('clientConfigService', downgradeInjectable(ClientConfigService));
app.factory('customerService', downgradeInjectable(CustomerService));
app.factory('auditTrailService', downgradeInjectable(AuditTrailService));

app.run(($stateRegistry, $urlService, $transitions, mailboxService, profileService, apiService, clientConfigService, customerService, auditTrailService) => {
  $urlService.rules.initial({state: 'app.search'});

  $transitions.onSuccess({ to: 'app.mailbox.**'}, function(transition) {
    
    mailboxService.mailboxClassName = transition.to().name.replace(/\./g,'-')
    // console.log(
    //     "Successful Transition from " + transition.from().name +
    //     " to " + transition.to().name
    // );
  });

  $transitions.onSuccess({ to: 'app.customerAudit.**'}, function(transition) {
    
    auditTrailService.auditTrailClassName = transition.to().name.replace(/\./g,'-')
    // console.log(
    //     "Successful Transition from " + transition.from().name +
    //     " to " + transition.to().name
    // );
  });

  $transitions.onError({ to: 'app.**'}, function(transition) {
    
    //window.location.href = apiService.loginUrl
    // console.log(
    //     "Successful Transition from " + transition.from().name +
    //     " to " + transition.to().name
    // );
  });

  // add resolve of checkLogin 
  // add resolve of getProfile
  $stateRegistry.register({
      name: 'app',
      abstract: true,
      template: `
        <header></header>
        <ui-view name="sidebar"></ui-view>
        <ui-view name="main" class="pageContent"></ui-view>
      `,
      resolve: { 
          loggedIn: loggedIn,
          profile: getProfile,
          clientConfig: getClientConfig
      }
  });

  // route to ng1 component
  $stateRegistry.register({
      url: '/search',
      name: 'app.search',
      views: {
        main: {
          controller: 'wpMarketplaceController',
          templateUrl:'./app/templates/search.template.html'
        },
        sidebar: {
          component: SidebarComponent
        }
      }
      
  });

  // route to ng1 component
  $stateRegistry.register({
      url: '/profile',
      name: 'app.profile',
      views: {
        main: {
          controller: 'wpMarketplaceController',
          templateUrl:'./app/templates/profile.template.html'
        },
        sidebar: {
          component: SidebarComponent
        }
      }
      
  });

   // route to ng1 component
  $stateRegistry.register({
      url: '/customer',
      name: 'app.customer',
      views: {
        main: {
          controller: 'wpMarketplaceController',
          templateUrl:'./app/templates/customer.template.html'
        },
        sidebar: {
          component: SidebarComponent
        }
      }
      
  });

  // route to ng1 component
  $stateRegistry.register({
      url: '/rewards1',
      name: 'app.rewards1',
      views: {
        main: {
          controller: 'wpMarketplaceController',
          templateUrl:'./app/templates/rewardCodes.template.html'
        },
        sidebar: {
          component: SidebarComponent
        }
      }
      
  });

  // route to ng1 component
  $stateRegistry.register({
      url: '/sellers',
      name: 'app.sellers',
      views: {
        main: {
          controller: 'wpMarketplaceController',
          templateUrl:'./app/templates/sellers.template.html'
        },
        sidebar: {
          component: SidebarComponent
        }
      }
      
  });

 // route to ng2 component
  $stateRegistry.register({
    url: '/rewards',
    name: 'app.rewards',
    views: {
      main: {
        component: RewardsComponent
      },
      sidebar: {
        component: SidebarComponent
      }
    }

  });

  $stateRegistry.register({
  url: '/edit/:rewardID',
  name: 'app.rewards.edit',
  views: {
    'overlay@app.rewards': {
      component: RewardsEditOverlayComponent
    }
  }

  });
  $stateRegistry.register({
    url: '/add',
    name: 'app.rewards.add',
    views: {
      'overlay@app.rewards': {
        component: RewardsEditOverlayComponent
      }
    }
  
    });

  $stateRegistry.register({
      url: '/mailbox/:customerId',
      name: 'app.mailbox',
      views: {
        main: {
          component: MailboxComponent
        },
        sidebar: {
          component: SidebarComponent
        }
      }

  });

  $stateRegistry.register({
      url: '/:id',
      name: 'app.mailbox.email',
      views: {
        preview: {
          component: MailboxPreviewComponent
        }
      }
  });

  $stateRegistry.register({
      url: '/convert',
      name: 'app.mailbox.email.convert',
      views: {
        'overlay@app.mailbox': {
          component: MailboxOverlayComponent
        }
      }
  });

  $stateRegistry.register({
    url: '/reply/:fromId',
    name: 'app.mailbox.email.reply',
    views: {
      'overlay@app.mailbox': {
        component: MailboxReplyComponent
      }
    }
});

  // separate to main app state, in order that resolve of checkLogin not triggered
  $stateRegistry.register({
      url: '/reissue?token',
      name: 'reissue',
      component: ReissueComponent
  });

  $stateRegistry.register({
      url: '/staff/audit',
      name: 'app.staffAudit',
      views: {
        main: {
          component: AuditTrailComponent
        },
        sidebar: {
          component: SidebarComponent
        }
      }
  });

  $stateRegistry.register({
      url: '/customer/:customerId/audit',
      name: 'app.customerAudit',
      views: {
        main: {
          component: AuditTrailComponent
        },
        sidebar: {
          component: SidebarComponent
        }
      }
  });

  $stateRegistry.register({
      url: '/add',
      name: 'app.customerAudit.add',
      views: {
        'overlay@app.customerAudit': {
          component: AuditTrailOverlayComponent
        }
      }
  });

});

// An AngularJS component
app.component('ng1Component', {
    template: `
      <h1>ng1 component</h1>
      <a ui-sref="app">Back to app</a>
      <ui-view></ui-view>
    `
})

// An Angular component
@Component({
    selector: 'ng2-component',
    template: `
      <h1>ng2 component</h1>
      <a uiSref="app">Back to app</a>
      <ui-view></ui-view>
    `
}) export class Ng2Component { }

export function loggedIn(apiService){

  return new Promise((resolve, reject) => {
    if(apiService.token){
      resolve(apiService.token)
    }else {
      reject()
    }
  })

}

export function getProfile(profileService){

  return profileService.retrieveProfile()

}

export function getClientConfig(clientConfigService){

  return clientConfigService.retrieveClientConfig()

}

/*
export function getStaffAuditTrail(auditTrailService){

  return auditTrailService.retrieveStaffAuditTrail();

}
/*

export function getAuditTrailCustomerItems(auditTrailService){

  return auditTrailService.retrieveStaffAuditTrail();

}

*/

// Using AngularJS config block, call `deferIntercept()`.
// This tells UI-Router to delay the initial URL sync (until all bootstrapping is complete)
app.config([ '$urlServiceProvider', $urlService => $urlService.deferIntercept() ]);

// Manually bootstrap the Angular app
platformBrowserDynamic().bootstrapModule(AppModule).then(platformRef => {
  const injector = platformRef.injector;
  const upgrade = injector.get(UpgradeModule) as UpgradeModule;

  // The DOM must be already be available
  upgrade.bootstrap(document.body, [app.name]);

  // Intialize the Angular Module (get() any UIRouter service from DI to initialize it)
  const url = injector.get(UrlService);

  // Instruct UIRouter to listen to URL changes
  url.listen();
  url.sync();
});

// An AngularJS component
// app.component('header', {
//     template: `
//       <nav class="navbar navbar-default hide-on-mobile">foobar
//         <div class="container-fluid">
//         <!-- Brand and toggle get grouped for better mobile display -->
//         <div class="navbar-header">
//           <!-- <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
//             <span class="sr-only">Toggle navigation</span>
//             <span class="icon-bar"></span>
//             <span class="icon-bar"></span>
//             <span class="icon-bar"></span>
//           </button> -->
//           <!-- <a class="navbar-brand" href="http://worryandpeace.com/">
//             <img ng-if="clientConfig.logo_black_background" src="{{clientConfig.logo_black_background}}" class="img-responsive" width="200px" style="display: inline-block;" alt="{{clientConfig.name}}">

//           </a> -->
//           <updating color="white" fontsize="16px" ng-model="updating" ng-if="updating"></updating>
//         </div>

//         <!-- Collect the nav links, forms, and other content for toggling -->
//         <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
//           <ul class="nav navbar-nav navbar-right">
//             <!-- <li><button class="btn btn-secondary" ng-click="openNewCustomerModal()">New Customer Modal - WIP</button></li> -->
//           </ul>
//         </div>
//       </div>
//     </nav>
//     `
// })

app.component('header', {
  template: `
      <updating color="black" fontsize="16px" ng-model="updating" ng-if="updating"></updating>
    `
})

/*
Defaults placed here by Angular CLI

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
*/


// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/rooster/admin/src/main.ts